var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fullscreen"}},[_c('v-img',{attrs:{"src":_vm.publicStateUrl(),"alt":"image","height":_vm.ImageHeight,"width":_vm.ImageWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }